import React, { useState, useEffect } from 'react';
import {
    Row, Col, Button, TabContent, TabPane, Nav, NavItem, NavLink,
    FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import AccountSelect from '../Account/AccountSelect';
import AccountCard from '../Account/AccountCard';
import classnames from 'classnames';
import { getCurrency, maskNumberString, getShortDate, usStates } from '../../Helper';
import { getFees, processPayment, getAccount, getPaymentTypes } from '../../API';
import FeePaymentCard from './FeePaymentCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faSquare, faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle, faCheckSquare, faCreditCard, faUser, faMapMarkerAlt, faMoneyCheck, faMoneyCheckAlt, faUniversity } from '@fortawesome/free-solid-svg-icons';
import { faCcAmex, faCcDiscover, faCcJcb, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import QueryString from 'query-string';
import PaymentSuccessModal from './PaymentSuccessModal';
import PaymentFailureModal from './PaymentFailureModal';
import CheckRegister from './CheckRegister';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';

function MakePayment(props) {
    const [activeTab, setActiveTab] = useState('selectAccount');
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const [fees, setFees] = useState([]);
    const [feePayments, setFeePayments] = useState([]);
    const [accountSelectModal, setAccountSelectModal] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState({ sslTransactionType: 'na', sslExpMonth: '01', sslBankAccountType: 1 });
    const [makingPayment, setMakingPayment] = useState(false);
    const [paymentUrl, setPaymentUrl] = useState('/admin/payments/');
    const [paymentSuccessModal, setPaymentSuccessModal] = useState(false);
    const [paymentFailureModal, setPaymentFailureModal] = useState(false);
    const [paymentFailureMessage, setPaymentFailureMessage] = useState('');

    const [FeeComment, setFeeComment] = useState('');

    useEffect(() => {
        checkQueryString();
        fetchPaymentTypes();
    }, []);

    const checkQueryString = async () => {
        if (props.location.search) {
            const qs = QueryString.parse(props.location.search);
            if (qs.accountId) {
                setSelectedAccounts([await getAccount(qs.accountId)]);
            }
        }
    };

    useEffect(() => {
        fetchFees();
    }, [selectedAccounts]);

    useEffect(() => {
        setFeePayments(fees.map(f => { return { feeID: f.feeID, paymentAmount: f.currentBalance } }));
    }, [fees]);

    const fetchPaymentTypes = async () => {
        setPaymentTypes(await getPaymentTypes());
    };

    const fetchFees = async () => {
        if (selectedAccounts.length > 0) {
            const fetchedFees = await getFees({ accountIds: selectedAccounts.map(so => so.accountID), paid: 0 });
            //fetchedFees.forEach(f => f.paymentAmount = f.currentBalance);
            setFees(fetchedFees);
        } else {
            setFees([]);
        }
    };

    const toggleAccountSelectModal = () => setAccountSelectModal(!accountSelectModal);

    const selectAccounts = (accounts) => {
        if (accounts !== null) {
            setSelectedAccounts(accounts);
        }
    };

    const cancelAccount = (accountId) => {
        setSelectedAccounts(selectedAccounts.filter(so => so.accountID !== accountId));
    };

    const accountCardOptions = {
        fields: {
            active: true,
            accountNumber: true,
            account: true,
            contact: false,
            address: false,
            email: false,
            balance: true
        },
        actions: {
            view: false,
            eidt: false,
            makePayment: false,
            generateLetter: false,
            delete: false,
            select: false,
            cancel: true
        }
    };

    const accountSelectOptions = {
        fields: {
            active: true,
            accountNumber: true,
            account: true,
            contact: false,
            address: false,
            email: false,
            balance: true
        },
        actions: {
            view: false,
            eidt: false,
            makePayment: false,
            generateLetter: false,
            delete: false,
            select: true,
            cancel: false
        }
    };

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const totalAmountDue = selectedAccounts.map(so => so.currentFeeBalance).reduce((a, b) => a + b, 0);
    const totalPaymentAmount = feePayments.map(fp => fp.paymentAmount).reduce((a, b) => a + b, 0);

    const updateFeePaymentAmount = (feeId, amount) => {
        let updatedFeePayments = [...feePayments];
        const feePaymentIndex = updatedFeePayments.findIndex(f => f.feeID === feeId);
        if (feePaymentIndex >= 0) {
            updatedFeePayments[feePaymentIndex].paymentAmount = isNaN(amount) ? 0 : amount;
            setFeePayments(updatedFeePayments);
        }
    };

    const updatePaymentInfo = (e) => {
        setPaymentInfo({ ...paymentInfo, [e.target.name]: e.target.value });
    };

    const updateCheck = (check) => {
        if (check !== null)
            setPaymentInfo({ ...paymentInfo, checkRegisterID: check.PK_ID, ...check });
    };

    const updateComment = (e) => {
        setFeeComment(e.target.value);
    };

    const makePaymentTransaction = async () => {
        setMakingPayment(true);

        const firstFee = fees !== null && fees.length > 0 ? fees[0] : null;
        const feeDescriptions = fees.map(f => f.account.accountNumber + ' ' + f.fiscalYear + ' ' + f.division.divisionName + ' ' + f.identifier);
        let feeDescription = feeDescriptions.join('; ');

        if (paymentInfo.sslTransactionType == 'other') {

            feeDescription = FeeComment

        }

        const paymentData = {
            feePayments: feePayments.filter(fp => fp.paymentAmount > 0),
            paymentInfo: {
                ...paymentInfo,
                sslCardExpDate: paymentInfo.sslExpMonth + paymentInfo.sslExpYear?.slice(-2),
                sslAmount: totalPaymentAmount,
                customFields: [
                    {
                        name: 'ssl_invoice_number',
                        value: firstFee !== null ? firstFee.account?.accountNumber.substring(0, 25) : ''
                    },
                    {
                        name: 'ssl_description',
                        value: feeDescription.substring(0, 255)
                    }
                ]
            }
        };

        try {
            const response = await processPayment(paymentData);
            console.log(response);
            if (response.ssl_result_message === 'APPROVAL') {
                console.log('SUCCESS!!!');
                setPaymentUrl('/admin/payments/' + response.payment.paymentID);
                setPaymentSuccessModal(true);
            } else {
                console.log('FAILURE!!! ' + response.ssl_result_message);
                setPaymentFailureMessage(response.ssl_result_message);
                setPaymentFailureModal(true);
            }

        } catch (ex) {
            console.log(ex);
            setPaymentFailureMessage('Error: ' + ex.message);
            setPaymentFailureModal(true);
        } finally {
            setMakingPayment(false);
        }
    };

    const makeAnotherPayment = () => {
        //Reset values
        setActiveTab('selectAccount');
        setSelectedAccounts([]);
        setFees([]);
        setFeePayments([]);
        setMakingPayment(false);
        setAccountSelectModal(false);
        setPaymentSuccessModal(false);
        setPaymentFailureModal(false);
        setPaymentUrl('/admin/payments/');
        setPaymentFailureMessage('');
    };

    const togglePaymentSuccessModal = () => setPaymentSuccessModal(!paymentSuccessModal);
    const togglePaymentFailureModal = () => setPaymentFailureModal(!paymentFailureModal);

    const selectedAccountsJSX = selectedAccounts.map(sa => {
        return (<AccountCard account={sa} key={sa.accountID} cancel={cancelAccount} options={accountCardOptions} />);
    });
    
    let paymentFormJSX = null;
    switch (paymentInfo.sslTransactionType) {
        case 'ccsale':
            paymentFormJSX = (
                <div>
                    <FormGroup>
                        <div className="accepted-cards">
                            <div title="American Express">
                                <FontAwesomeIcon icon={faCcAmex} />
                            </div>
                            <div title="Discover">
                                <FontAwesomeIcon icon={faCcDiscover} />
                            </div>
                            <div title="JCB">
                                <FontAwesomeIcon icon={faCcJcb} />
                            </div>

                            <div title="Visa">
                                <FontAwesomeIcon icon={faCcVisa} />
                            </div>
                        </div>
                        <div className="surcharge-disclaimer">
                        All credit card payments must pay an additional 2.5% processing fee.
                        </div>
                    </FormGroup>
                    <Row xs={1} md={2} lg={3} xl={4}>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faCreditCard} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Card Number" name="sslCardNumber" value={paymentInfo.sslCardNumber || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faCreditCard} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="CVC" name="sslCvv2Cvc2" value={paymentInfo.sslCvv2Cvc2 || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="First Name" name="sslFirstName" value={paymentInfo.sslFirstName || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Last Name" name="sslLastName" value={paymentInfo.sslLastName || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faCalendarAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="select" placeholder="Expiration Month" name="sslExpMonth" value={paymentInfo.sslExpMonth || '01'} onChange={updatePaymentInfo}>
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faCalendarAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Expiration Year" name="sslExpYear" value={paymentInfo.sslExpYear || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row xs={1} md={2} lg={3} xl={4}>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Address" name="sslAvsAddress" value={paymentInfo.sslAvsAddress || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="City" name="sslCity" value={paymentInfo.sslCity || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="select" name="sslState" value={paymentInfo.sslState} onChange={updatePaymentInfo}>
                                        {usStates.map(s => (<option key={s.abbreviation} value={s.abbreviation}>{s.name}</option>))}
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Zip Code" name="sslAvsZip" value={paymentInfo.sslAvsZip || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            );
            break;
        case 'ecspurchase':
            paymentFormJSX = (
                <div>
                    <FormGroup>
                        <div className="surcharge-disclaimer">
                            All ACH payments must pay an additional $2.50 processing fee.
                        </div>
                    </FormGroup>
                    <Row xs={1} md={2} lg={3} xl={4}>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faUniversity} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="select" placeholder="Bank Account TYpe" name="sslBankAccountType" value={paymentInfo.sslBankAccountType || 1} onChange={updatePaymentInfo}>
                                        <option value={1}>Business</option>
                                        <option value={0}>Personal</option>
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMoneyCheck} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Company Name" name="sslCompany" value={paymentInfo.sslCompany || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMoneyCheck} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Account Number" name="sslBankAccountNumber" value={paymentInfo.sslBankAccountNumber || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMoneyCheck} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Routing Number" name="sslRoutingNumber" value={paymentInfo.sslRoutingNumber || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="First Name" name="sslFirstName" value={paymentInfo.sslFirstName || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Last Name" name="sslLastName" value={paymentInfo.sslLastName || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row xs={1} md={2} lg={3} xl={4}>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Address" name="sslAvsAddress" value={paymentInfo.sslAvsAddress || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="City" name="sslCity" value={paymentInfo.sslCity || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="select" name="sslState" value={paymentInfo.sslState} onChange={updatePaymentInfo}>
                                        {usStates.map(s => (<option key={s.abbreviation} value={s.abbreviation}>{s.name}</option>))}
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Zip Code" name="sslAvsZip" value={paymentInfo.sslAvsZip || ''} onChange={updatePaymentInfo} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            );
            break;
        case 'pc':
            paymentFormJSX = (
                <CheckRegister updateCheck={updateCheck} />
            );
            break;
        case 'other':
            paymentFormJSX = (
                <FormGroup>
                    <InputGroup>
                        <Input placeholder="Fee Comments" name="txtFeeComment" value={FeeComment || ''} onChange={updateComment} />
                    </InputGroup>
                </FormGroup>
                );
        default:
            break;
    }

    let reviewFeesJSX = (
        <table className="table">
            <thead>
                <tr>
                    <th>Account Number</th>
                    <th>Permit Number/EPA ID</th>
                    <th>Division</th>
                    <th>Description</th>
                    <th>Payment Amount</th>
                </tr>
            </thead>
            <tbody>
                {feePayments.filter(fp => fp.paymentAmount > 0).map(fp => {
                    const f = fees.find(f => f.feeID === fp.feeID);
                    if (!f) return null;
                    return (<tr key={fp.feeID}>
                        <td>
                            {f.account.accountNumber}
                        </td>
                        <td>
                            {f.identifier}
                        </td>
                        <td>
                            {f.division?.divisionName}
                        </td>
                        <td>
                            {f.feeDescription}
                        </td>
                        <td>
                            {getCurrency(fp.paymentAmount)}
                        </td>
                    </tr>)
                })}
            </tbody>
            <tfoot>
                <tr>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                        <strong>{getCurrency(totalPaymentAmount)}</strong>
                    </td>
                </tr>
            </tfoot>
        </table>
    );
    let reviewPaymentJSX = null;
    switch (paymentInfo.sslTransactionType) {
        case 'ccsale':
            reviewPaymentJSX = (
                <div>
                    <div><span><strong>Credit Card:</strong></span> <span>{maskNumberString(paymentInfo.sslCardNumber, 4, "*")}</span></div>
                    <div><span><strong>Name:</strong></span> <span>{(paymentInfo.sslFirstName || '') + ' ' + (paymentInfo.sslLastName || '')}</span></div>
                    <div><span><strong>Address:</strong></span> <span>{(paymentInfo.sslAvsAddress || '') + ' ' + (paymentInfo.sslCity || '') + ', ' + (paymentInfo.sslState || '') + ' ' + (paymentInfo.sslAvsZip || '')}</span></div>
                </div>
            );
            break;
        case 'ecspurchase':
            reviewPaymentJSX = (
                <div>
                    <div><span><strong>eCheck:</strong></span> <span>{maskNumberString(paymentInfo.sslBankAccountNumber, 4, "*")}</span></div>
                    <div><span><strong>Name:</strong></span> <span>{(paymentInfo.sslFirstName || '') + ' ' + (paymentInfo.sslLastName || '')}</span></div>
                    <div><span><strong>Address:</strong></span> <span>{(paymentInfo.sslAvsAddress || '') + ' ' + (paymentInfo.sslCity || '') + ', ' + (paymentInfo.sslState || '') + ' ' + (paymentInfo.sslAvsZip || '')}</span></div>
                </div>
            );
            break;
        case 'pc':
            reviewPaymentJSX = (
                <div>
                    <div><span><strong>Paper Check:</strong></span> <span>{paymentInfo.CheckNum}</span></div>
                    <div><span><strong>DANR Program:</strong></span> <span>{paymentInfo.Program}</span></div>
                    <div><span><strong>Payment For:</strong></span> <span>{paymentInfo.FeeType}</span></div>
                    <div><span><strong>Check From:</strong></span> <span>{paymentInfo.CheckFrom}</span></div>
                    <div><span><strong>Check Amount:</strong></span> <span>{getCurrency(paymentInfo.Amount)}</span></div>
                    <div><span><strong>Check Date:</strong></span> <span>{getShortDate(paymentInfo.CheckDate)}</span></div>
                    <div><span><strong>Received Date:</strong></span> <span>{getShortDate(paymentInfo.RecdDate)}</span></div>
                </div>
            );
            break;
        case 'noncashvoucher':
            reviewPaymentJSX = (
                <div>
                    <div><span><strong>Non-Cash Voucher</strong></span></div>
                </div>
            );
            break;
        case 'other':
            reviewPaymentJSX = (
                <div>
                    <div><span><strong>Other Payment type</strong></span></div>
                </div>
            );
            break;
        default:
            break;
    }

    const feeBalance = feePayments.filter(fp => fp.paymentAmount > 0).map(fp => fp.paymentAmount).reduce((a, b) => a + b, 0);
    let totalBalance = feeBalance;

    switch (paymentInfo.sslTransactionType) {
        case 'ccsale':
            //totalBalance = Math.ceil(100 * feeBalance / 0.975) / 100;
            totalBalance = Math.ceil(100 * feeBalance * 1.025) / 100;
            break;
        case 'ecspurchase':
            totalBalance = feeBalance + 2.5;
            break;
        default:
            break;
    }

    const processingFee = totalBalance - feeBalance;

    return (
        <div id="makePayment">
            <Row className="header-row">
                <Col>
                    <h1>Make Payment</h1>
                </Col>
            </Row>
            <Row className="tabs-row">
                <Col>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'selectAccount' })}
                                onClick={() => { toggle('selectAccount'); }}>
                                Select Accounts
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'choosePayment' })}
                                onClick={() => { toggle('choosePayment'); }}>
                                Choose Payment
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'paymentInfo' })}
                                onClick={() => { toggle('paymentInfo'); }}>
                                Payment Info
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'reviewSubmit' })}
                                onClick={() => { toggle('reviewSubmit'); }}>
                                Review and Submit
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
            </Row>
            <Row className="tab-content-row">
                <Col>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="selectAccount">
                            <div className="select-btn">
                                <Button color="danr-green" className="btn-block" onClick={toggleAccountSelectModal}><span>Select Accounts</span></Button>
                            </div>
                            <Row>
                                <Col>
                                    {selectedAccountsJSX}
                                </Col>
                            </Row>
                            <div className="tab-nav-button">
                                <div></div>
                                <Button color="danr-green" onClick={() => { toggle('choosePayment'); }}><span>Next</span></Button>
                            </div>
                        </TabPane>
                        <TabPane tabId="choosePayment">
                            <Row>
                                <Col>
                                    <span><strong>Total Amount Due:</strong></span> <span>{getCurrency(totalAmountDue)}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span><strong>Total Payment Amount:</strong></span> <span>{getCurrency(totalPaymentAmount)}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {fees.map(f => feePayments.some(fp => fp.feeID === f.feeID) ? (<FeePaymentCard key={f.feeID} fee={f} feePayment={feePayments.find(fp => fp.feeID === f.feeID)} updateFeePaymentAmount={updateFeePaymentAmount} />) : null)}
                                </Col>
                            </Row>
                            <div className="tab-nav-button">
                                <Button color="danr-red" onClick={() => { toggle('selectAccount'); }}><span>Back</span></Button>
                                <Button color="danr-green" onClick={() => { toggle('paymentInfo'); }}><span>Next</span></Button>
                            </div>
                        </TabPane>
                        <TabPane tabId="paymentInfo">
                            <Row xs={1} md={2} lg={3} xl={4}>
                                <Col>
                                    <FormGroup>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText><FontAwesomeIcon icon={faMoneyCheckAlt} /></InputGroupText>
                                            </InputGroupAddon>
                                            <Input type="select" name="sslTransactionType" value={paymentInfo.sslTransactionType} onChange={updatePaymentInfo}>
                                                <option value="na">Select Payment Type</option>
                                                {paymentTypes.map(pt => (<option key={pt.paymentTypeID} value={pt.transactionType}>{pt.paymentTypeName}</option>))}
                                            </Input>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {paymentFormJSX}
                            <div className="tab-nav-button">
                                <Button color="danr-red" onClick={() => { toggle('choosePayment'); }}><span>Back</span></Button>
                                <Button color="danr-green" onClick={() => { toggle('reviewSubmit'); }}><span>Next</span></Button>
                            </div>
                        </TabPane>
                        <TabPane tabId="reviewSubmit">
                            <Row>
                                <Col>
                                    {reviewFeesJSX}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="totals">
                                        <div className="subtotal"><strong>Subtotal:</strong> <span className="subtotal-value">{getCurrency(feeBalance)}</span></div>
                                        <div className="processing-fee"><strong>Processing Fee:</strong> <span className="processing-fee-value">{getCurrency(processingFee)}</span></div>
                                        <div className="grand-total"><strong>Grand Total:</strong> <span className="grand-total-value">{getCurrency(totalBalance)}</span></div>
                                    </div>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col>
                                    {reviewPaymentJSX}
                                </Col>
                            </Row>
                            <div className="tab-nav-button">
                                <Button color="danr-red" onClick={() => { toggle('paymentInfo'); }}><span>Back</span></Button>
                                <Button color="danr-green" onClick={makePaymentTransaction} disabled={makingPayment}><span>Submit</span></Button>
                            </div>
                            {makingPayment ?
                                <div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>
                                : null}
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
            <AccountSelect multiple={true} open={accountSelectModal} toggle={toggleAccountSelectModal} select={selectAccounts} accountCardOptions={accountSelectOptions} searchOptions={{ hasUnpaidFees: true }} />
            <PaymentSuccessModal open={paymentSuccessModal} toggle={togglePaymentSuccessModal} makeAnotherPayment={makeAnotherPayment} paymentUrl={paymentUrl} />
            <PaymentFailureModal open={paymentFailureModal} toggle={togglePaymentFailureModal} message={paymentFailureMessage} />
        </div>
    );
}

export default MakePayment;